/*
 * @Descripttion: 
 * @version: V1.0.0
 * @Author: zym
 * @Date: 2023-10-18 15:41:35
 */
let baseUrl = process.env.VUE_APP_HTTP_BASE_URL;

let api = {};

api.xfChatInit = baseUrl + '/chat/init'


api.inputAssociate = baseUrl + '/chat/inputAssociate'

api.saveResult  = baseUrl + '/chat/saveResult'

api.discernAudio  = baseUrl + '/chat/discernAudio'

api.saveALLResult  = baseUrl + '/chat/saveALLResult'

api.questionnaire  = baseUrl + '/chat/questionnaire'

api.upload  = baseUrl + '/chat/upload'

api.conmpoundAudio  = baseUrl + '/chat/conmpoundAudio'



export default api